<script setup>
import { ref, watch } from "vue";
import { Head, Link, useForm } from "@inertiajs/vue3";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VAlert from "@/Shared/VAlert.vue";
import VDevider from "@/Shared/VDevider.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VHeaderButtonInfo from "@/Shared/HeaderButton/VButtonInfo.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";

const props = defineProps({
    title: String,
    additional: Array,
});

const form = useForm({
    title: props.additional.location.title,
    _method: "PUT",
});

const breadcrumbs = [
    {
        url: props.additional.urlIndex,
        label: "Location",
    },
    {
        url: "#",
        label: "Edit",
    },
];

const submit = () => {
    form.post(props.additional.urlUpdate, {
        preserveScroll: true,
    });
};
</script>

<template>
    <Head>
        <title>Edit - Location Management</title>
    </Head>
    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="additional.urlIndex"
                        :filters="additional.filters ?? {}"
                    >
                        Edit Location
                    </VTitleWithBackLink>
                    <div class="btn-wrapper">
                        <VHeaderButtonInfo
                            v-if="additionalcanView"
                            :href="urlShow"
                        />
                    </div>
                </div>

                <VDevider />
                <VAlert />

                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="title"
                                label="Location"
                                type="text"
                                :error="form.errors.title"
                                v-model:value="form.title"
                            />
                        </div>
                    </div>

                    <div class="text-end">
                        <VButtonSubmit
                            type="submit"
                            :isProcessing="form.processing"
                        >
                            Submit
                        </VButtonSubmit>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
